module.exports = __webpack_public_path__ + "img/lesson4.4d381459.png";